import React from 'react';

/**
 * 34×20 pill toggle. ON = --accent bg with soft glow. OFF = --bg-surface-2
 * with --border-default. 16px white thumb that translates 14px.
 *
 * Used for "Manual billing override" on the Overview Settings panel.
 */
export default function Toggle({ on, onClick, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!on}
      disabled={disabled}
      onClick={onClick}
      style={{
        position: 'relative',
        width: 34,
        height: 20,
        borderRadius: 999,
        border: '1px solid',
        borderColor: on ? 'var(--accent)' : 'var(--border-default)',
        background: on ? 'var(--accent)' : 'var(--bg-surface-2)',
        boxShadow: on ? '0 1px 2px color-mix(in oklch, var(--accent) 30%, transparent)' : 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        padding: 0,
        flexShrink: 0,
        transition: 'background 120ms ease, border-color 120ms ease',
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: 1,
          left: on ? 15 : 1,
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: '#ffffff',
          boxShadow: '0 1px 2px oklch(0 0 0 / 0.18)',
          transition: 'left 120ms ease',
        }}
      />
    </button>
  );
}
